import {
  Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent,
  DialogTitle, Table, TableBody, TableCell, TableHead, TableRow, Typography
} from '@material-ui/core';
import {Check, ListAlt} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import {useEffect, useState} from 'react';
import { useNotify } from 'react-admin';
import {
  useQuizAssessmentTestDataProvider
} from "../../../providers/data-provider/quiz-assessment-test.data.provider";

const useStyles = makeStyles(() => ({
  headerCell: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  bodyCell: {
    whiteSpace: 'nowrap',
  },
}));

const ANSWER_OPTIONS = ['A', 'B', 'C', 'D', 'E'];

export function RightAnswersAction({ testId, studentName }) {
  const classes = useStyles();
  const [answerKey, setAnswerKey] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { getAvailabilityAnswerKey } = useQuizAssessmentTestDataProvider()
  const notify = useNotify();

  useEffect(() => {
    if (!open) {
      setAnswerKey([]);
      return;
    }
    setLoading(true);
    getAvailabilityAnswerKey(testId)
      .then(res => {
        setAnswerKey(res.data)
      })
      .catch(() => {
        notify('Erro ao carregar as respostas', 'warning');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [open, testId]);

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={<ListAlt />}
        onClick={() => setOpen(true)}
      >
        Gabarito
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Respostas{studentName ? ` - ${studentName}` : ''}</DialogTitle>
        <DialogContent>
          {loading ? (
            <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" gridGap={16} minHeight={200}>
              <CircularProgress />
              <Typography variant="body2" color="textSecondary">Carregando respostas</Typography>
            </Box>
          ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Questão</TableCell>
                {ANSWER_OPTIONS.map((letter) => (
                  <TableCell key={letter} className={classes.headerCell} align="center">
                    {letter}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {answerKey.map((question) => (
                <TableRow key={question.questionId}>
                  <TableCell className={classes.headerCell}>
                    <Typography variant="body2">{question.questionNumber} - {question.shortQuestion}</Typography>
                  </TableCell>
                  {
                    ANSWER_OPTIONS.map((letter, idx) => {
                      const opt = question.options?.[idx];
                      const isRight = opt && opt.id === question.correctOptionId;
                      return (
                        <TableCell key={question.questionId + letter} className={classes.bodyCell} align="center">
                          <Box display="flex" alignItems="center" justifyContent="center">
                            {isRight ? <Check color={'primary'} /> : <Checkbox disabled />}
                          </Box>
                        </TableCell>
                      )
                    })
                  }
                </TableRow>
              ))}
            </TableBody>
          </Table>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="default">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
